import React, { useState, lazy } from 'react';
type ImageWithFallbackProps = {
  src: string;
  alt: string;
  className?: string;
  containerClassName?: string;
};
export function ImageWithFallback({
  src,
  alt,
  className = '',
  containerClassName = ''
}: ImageWithFallbackProps) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <div className={`flex items-center justify-center bg-slate-800 text-center text-xs text-slate-400 ${containerClassName}`} role="img" aria-label={alt} data-id="element-9" data-mp="3lxnhbarl68td">
        Vista previa no disponible
      </div>;
  }
  return <img src={src} alt={alt} className={className} loading="lazy" onError={() => setFailed(true)} data-id="element-10" data-mp="3rsfud077v1m" />;
}